import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { restServices } from 'src/app/rest.service';
import { CambioBce } from '../../models/entities/cambio-bce';

@Injectable()
export class CambioBceService {

  resourceUrl = environment.api_rischiocambio_url + restServices.cambioBce;

  constructor(private http: HttpClient) { }

  getCambiBceByDominioCrossId(dominioCrossId: number) {
    return this.http.get<CambioBce[]>(`${this.resourceUrl}/by-dominio-cross/${dominioCrossId}`, { observe: 'response' });
  }

}